import http from '@/utils/http';

const questionnaireApi = {
  /**
   * 商户获取单个问卷
   * @returns {Promise<unknown>}
   * @param params
   */
  getSurvey(params) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    params = JSON.stringify(params);
    return http
      .post('/workscene/workscene/v1/notice/getDetail', params, headers)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  /**
   * 获取问卷详情
   * @param params
   * @returns {Promise<unknown>}
   */
  getSurveyDetail(params) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    return http
      .get('/workscene/workscene/v1/survey/resp/b', params, headers)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  /**
   * 提交问卷
   * @param params
   * @returns {Promise<unknown>}
   */
  submitSurvey(params) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    return http
      .post('/workscene/workscene/v1/survey/resp/b', params, headers)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 商户-分享会评分
  scoreAdd(params) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    params = JSON.stringify(params);
    return http
      .post('/workscene/workscene/v1/score/add', params, headers)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
};

export default questionnaireApi;
